




































import { defineComponent, PropType, ref, toRef } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import useModal from "@/hooks/useModal";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "ModalView",
  components: { PageTitle, BaseIcon, CustomScroll },
  props: {
    title: { type: String as PropType<TranslateResult | string> },
    scrollable: { type: Boolean, default: true },
    closable: { type: Boolean, default: true },
    value: { type: Boolean, required: true },
    safeMode: { type: Boolean, default: false },
    darkOverlay: { type: Boolean, default: false },
    elongated: { type: Boolean, default: false },
    autoHeight: { type: Boolean, default: false },
  },
  setup(props) {
    const { modalClose } = useModal(toRef(props, "value"), props.closable);
    const modalBodyRef = ref<HTMLDivElement>();

    return {
      modalClose,
      modalBodyRef,
    };
  },
});
